<template>
  <div class="submit-page">
    <div class="title1">恭喜您！</div>
    <div class="title2">已解锁个性化营养服务!</div>
    <div class="title3">营养师会在营期中为您提供更多针对性帮助~</div>
    <div class="list">
      <div class="item">
        <span class="iconfont icon-gou"></span>
        <span>专业饮食指导</span>
      </div>
      <div class="item">
        <span class="iconfont icon-gou"></span>
        <span>陪伴式服务</span>
      </div>
      <div class="item">
        <span class="iconfont icon-gou"></span>
        <span>专业系统减脂课程</span>
      </div>
    </div>
    <img
      class="image"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e26db5bd6551d1dec191419541956445.png"
      alt=""
    />
    <div class="desc"
      >关闭页面，<span class="tip">找陪伴官领取【开营指南】</span
      ><br />一起开启变美之旅吧!</div
    >
    <div class="btn" @click="bindClose">我知道了</div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {}
  },
  created() {},
  methods: {
    bindClose() {
      if (this.$betterwe.isApp()) {
        this.$betterwe.onAppCloseRoute()
      } else {
        if (window.__wxjs_environment === 'miniprogram') {
          wx.miniProgram.navigateBack()
        } else {
          window['wx']['closeWindow']()
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.submit-page {
  background: #f9f9f9;
  min-height: 100vh;
  box-sizing: border-box;
  padding: 41px 35px 50px;

  .title1 {
    font-weight: bold;
    font-size: 30px;
    color: rgba(0, 0, 0, 0.9);
    line-height: 32px;
    margin-bottom: 5px;
  }

  .title2 {
    font-weight: bold;
    font-size: 20px;
    color: rgba(0, 0, 0, 0.9);
    line-height: 32px;
  }

  .title3 {
    font-size: 13px;
    color: rgba(0, 0, 0, 0.9);
    line-height: 22px;
    margin-bottom: 7px;
  }

  .list {
    font-size: 12px;
    margin-bottom: 10px;
    line-height: 22px;
    color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    border-top: 1px solid rgba(0, 0, 0, 0.12);

    .item {
      display: flex;
      align-items: center;
      margin-right: 10px;
      white-space: nowrap;

      .iconfont {
        margin-right: 6px;
        width: 13px;
        height: 13px;
        color: #fff;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 10px;
        background: linear-gradient(179deg, #a7ef72 0%, #1ccc5d 100%);
      }
    }

    .item:last-child {
      margin-right: 0;
    }
  }

  .image {
    width: 100%;
    height: 332px;
    margin-bottom: 30px;
  }

  .desc {
    font-size: 10px;
    color: rgba(0, 0, 0, 0.5);
    line-height: 22px;
    text-align: center;
    margin-bottom: 76px;
    .tip {
      font-weight: bold;
      color: rgba(0, 0, 0, 0.8);
    }
  }

  .btn {
    text-align: center;
    width: 205px;
    height: 44px;
    line-height: 44px;
    margin: 0 auto;
    background: #ff2c4c;
    box-shadow: 0px 3px 8px 0px rgba(255, 44, 76, 0.16);
    border-radius: 24px;
    font-weight: bold;
    font-size: 15px;
    color: #ffffff;
  }
}
</style>
